import React from "react";
import { Link } from "react-router-dom";

import NavBar from "../../components/NavBar/NavBar";
import Prefer from "../../components/Prefer/Prefer";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import Footer from "../../components/Footer/Footer";

import Industry1 from "../../images/industry1.png";
import Industry2 from "../../images/industry2.png";

import "./Industry.css";

const Industry = () => {
  return (
    <div className="industry">
      <NavBar white />
      <div className="industry__hero container">
        <div>
          <h1 className="font-heading">
            See the <span>Diverse Industries</span> We Work In
          </h1>
          <p className="font-normal mt-20">
            Our Solutions are ever availbale to serve your need as we provide
            easy access to meet every of your need. We will never do lesser.
          </p>
          <Link
            className="d-block mt-20 py-20 px-40 text-center font-bold font-bigger"
            to="/quote"
          >
            Instant Quote
          </Link>
        </div>
      </div>
      <div className="industry__services container mt-40">
        <div className="industry__services__top mt-20 text-center">
          <h2 className="font-heading font-bolder">
            Industries we work with across the globe
          </h2>
          <p className="font-heavy font-big my-20 w-70 mx-auto">
            We have translated content for various industries such as finance,
            law, and healthcare. We also offer language interpretation services
            for meetings and other events.
          </p>
        </div>
        <div className="industry__cards">
          <div>
            <h2 className="font-subhead">E-Learning & Education</h2>
            <p>
              Our clients include government institutions, international trade
              companies, multinational corporations, and universities. We offer
              both language-based and culture-based translations, which means we
              can provide you customers with documents in their native language
              as well as documents that reflect their culture accurately. The
              industry is facing a dilemma due to the lack of sufficient skilled
              translators in the educational sector thats why we here to provide
              the best language translation and interpretation services.
            </p>
          </div>
          <div>
            <h2 className="font-subhead">Marketing</h2>
            <p>
              Today, marketing industry is in such a state that the most
              important step to the success is not a website or landing page but
              an effective translation service provider. A reliable translation
              service provider is a must for any business who wants to expand
              internationally and rapidly grow their market share.
            </p>
          </div>
        </div>
        <div className="industry__services__body industry__services__info d-flex flex-row-reverse align-center justify-center">
          <div className="industry__services__list">
            <div>
              <h2>We Render Our Services in</h2>
              <h3>IT & Software</h3>
              <p>
                Companies in the IT and software industries are now starting to
                use translation services on a regular basis. This is due to the
                increasing number of people who are not fluent in English or the
                language that they have been asked to translate into.
                Oneconverse Translation service provides wide-ranging options
                for businesses that need translation work done. These
                professional translation services offer translations for all
                languages and can help you save a lot of time when it comes down
                sourcing translators.
              </p>
            </div>
          </div>
          <div className="industry__image">
            <img src={Industry1} alt="" />
          </div>
        </div>
        <div className="industry__cards">
          <div>
            <h2 className="font-subhead">Blockchain & Crypto</h2>
            <p>
              Digital agencies that work in the blockchain industry often need
              to create content for their clients in multiple languages The
              blockchain is a public ledger of transactions that are verified
              and maintained by a decentralized network of computers.
              Oneconverse is the best translation service provider, who will
              help you with your translation tasks and give you the best pricing
              with real-time chat. We will offer you the best quality
              translation with high-quality customer support team to handle all
              your translation needs!
            </p>
          </div>
          <div className="industry__cards__small">
            <h2 className="font-subhead">Gaming</h2>
            <p>
              The gaming industry is a fast-growing industry with a lot of work
              to be done. We make sure that the right messages are conveyed to
              the right audience, we are able to provide a quality translation
              service at an affordable cost, caters to both email marketing and
              website translations and also capable of translating for over 150
              Countries.
            </p>
          </div>
        </div>
        <div className="industry__services__body industry__services__info d-flex flex-row-reverse align-center justify-center">
          <div className="industry__image__2">
            <img src={Industry2} alt="" />
          </div>
          <div className="industry__services__list">
            <div>
              <h2>We Render Our Services in</h2>
              <h3>Retail & E-Commerce</h3>
              <p>
                Oneconverse service is the best choice for retailers and
                e-commerce companies. It helps them reach customers from across
                the world. The translation service provider needs to have a team
                of linguists with good command over languages like French,
                Spanish, Chinese, Japanese etc. These linguists can work on
                multiple projects simultaneously and provide assistance to
                US-based clients with their non-English communication need.
              </p>
            </div>
          </div>
        </div>
        <div className="industry__cards">
          <div>
            <h2 className="font-subhead">Government & NGO</h2>
            <p>
              The number of government and NGO industries are growing
              exponentially, which is why the need for quality translation
              services provider is also growing. We understand how crucial it is
              to make sure that content that has been translated from one
              language to another matches the style of the original text. These
              companies are able to provide translations without adversely
              affecting the integrity of content.
            </p>
          </div>
          <div className="industry__cards__small">
            <h2 className="font-subhead">Entertainment</h2>
            <p>
              The entertainment industry plays a significant role in the global
              economy. There is a wide array of content that is created for
              various purposes. One of the most important tasks in the
              entertainment industry is translation and localization.
            </p>
          </div>
        </div>
      </div>
      <div className="industry__banner container">
        <div>
          <h1 className="font-heavy font-normal">WE ARE READY TO HELP</h1>
          <h2 className="font-heading font-bold mb-40">
            This is not the end, we have more to offer to you.
          </h2>
          <Link to="/contact-us">Talk To Us</Link>
        </div>
      </div>
      <Prefer />
      <div className="container">
        <InstantQuote />
      </div>
      <Footer />
    </div>
  );
};

export default Industry;
